<template>
  <div class="disburse__options-container">
    <div class="disburse__options">
      <!--single payment-->
      <div class="disburse__option" @click="single()" :class="{'active': ifSingle}">
        <div class="radio__item radio__item__flex radio-container">
          <input type="radio" class="radio__item__input" name="disburse-option" id="disburseSingle" :checked="ifSingle">
          <label for="disburseSingle" class="radio__item__label">Single payment</label>
        </div>
      </div>
      
      
      <!--recurring transfer-->
      <div class="disburse__option hide" @click="recurring()" :class="{'active': ifRecurring}">
        <div class="radio__item radio__item__flex radio-container">
          <input type="radio" class="radio__item__input" name="disburse-option" id="disburseRecurring"  :checked="ifRecurring">
          <label for="disburseRecurring" class="radio__item__label">Recurring transfer</label>
        </div>
      </div>
      
      <!--bulk transfer-->
      <div class="disburse__option" @click="bulk()" :class="{'active': ifBulk}">
        <div class="radio__item radio__item__flex radio-container">
          <input type="radio" class="radio__item__input" name="disburse-option" id="disburseBulk"  :checked="ifBulk">
          <label for="disburseBulk" class="radio__item__label">Bulk upload</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    
    created(){
      this.routeSelected();
    },
  
    watch: {
      // call again the fetch method if the route changes
      '$route': 'routeSelected'
    },
    
    data() {
      return {
        active: false,
        ifSingle:false,
        ifRecurring:false,
        ifBulk: false,
      }
    },
    methods:{
      single(){
       return this.$router.replace({ name: 'single-disburse'});
      },
      recurring(){
        return this.$router.replace({ name: 'schedule-recurring'});
      },
      bulk(){
        return this.$router.replace({ name: 'bulk-disburse'});
      },
     
      routeSelected(){
        if (this.$route.name ==='single-disburse' || this.$route.name === 'single-disburse-id'){
          this.ifSingle = true;
        }
        if (this.$route.name ==='schedule-recurring'){
          this.ifRecurring = true;
        }
        if (this.$route.name ==='bulk-disburse'){
          this.ifBulk = true;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/partials/DisburseOptions.vue